import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import TixService from './tixService';

const MAX_EVENT_QUEUE = 10;
let eventQueue = [];

const logger = Logger.getLogger('wanderu-service-wapi:tixEventLogger');

function formatData(type, data) {
    return {
        eventType: type,
        timestamp: Date.now(),
        hostname: window.location.hostname,
        metadata: {
            networkUserId: SnowplowService.getNetworkUserId(),
            ...SnowplowService.getDomainUserInfo(),
        },
        path: window.location.pathname,
        properties: data,
    };
}

function sendNow(type, data) {
    addToQueue(type, data, true);
}

function addToQueue(type, data, postNow = false) {
    const event = formatData(type, data);
    eventQueue.push(event);

    if (eventQueue.length >= MAX_EVENT_QUEUE || postNow) {
        postQueue();
    }
}

async function postQueue() {
    try {
        await TixService.post('v3/events', { body: eventQueue });

        clearEventQueue();
    } catch (ex) {
        logger.error('postQueue', ex);
    }
}

function clearEventQueue() {
    eventQueue = [];
}

export default {
    sendNow,
    addToQueue,
};
